export type ConditionalOperator =
    | 'equals'
    | 'notEquals'
    | 'contains'
    | 'startsWith'
    | 'isEmpty'
    | 'isNotEmpty'
    | 'greaterThan'
    | 'lessThan';

export const CONDITIONAL_OPERATOR_LABELS: Record<ConditionalOperator, string> = {
    equals: 'equals',
    notEquals: 'does not equal',
    contains: 'contains',
    startsWith: 'starts with',
    isEmpty: 'is empty',
    isNotEmpty: 'is not empty',
    greaterThan: 'is greater than',
    lessThan: 'is less than',
};

/** Whether the operator requires a comparison value (isEmpty/isNotEmpty do not) */
export const operatorRequiresValue = (operator: ConditionalOperator): boolean => {
    return operator !== 'isEmpty' && operator !== 'isNotEmpty';
};

export interface ConditionalCondition {
    /** The associatedVariable of the field to check (e.g. "{posName}") */
    fieldAssociatedVariable: string
    operator: ConditionalOperator
    /** The value to compare against (not used for isEmpty/isNotEmpty) */
    value?: string
    /** The default value to use when this condition matches */
    defaultValue: string
}

export interface ConditionalDefault {
    conditions: ConditionalCondition[]
    /** Fallback value if no conditions match */
    otherwise?: string
}

/** Clipboard tag used to identify a copied ConditionalDefault payload */
export const CLIPBOARD_TAG = '__voicifyCDE';
